// Also filter older server responses while the audit functions are being upgraded.
const categories = new Set([
  "Pass", "Bokning", "Användare", "Frånvaro", "Övertid", "Lönetyp", "Frånvarotyp",
  "OB-regel", "Övertidsregel", "Helgdag", "OB-tillägg", "Regel", "Lönegodkännande",
  "Personalgrupp", "Arbetstidsmått", "Inbjudan",
]);
export function isVisibleAuditEntry(entry) {
  if (entry.category === "Rapport") {
    return entry.action === "updated" && (entry.changes || []).some(({ field }) => ["isRead", "Läst"].includes(field));
  }
  if (entry.category === "Tidsschema") {
    return (entry.changes || []).some(({ field }) => /visibleEmployeeIds|Schemamedlemmar/.test(field));
  }
  return categories.has(entry.category);
}
